var _style, _path, _path2, _path3, _path4, _path5, _path6, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 568 541",
    style: {
      enableBackground: "new 0 0 568 541"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:22.4;stroke-linecap:round;stroke-miterlimit:56;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.2,82.2c23.7-28.3,58.8-45.1,96-45.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M511.4,246.6c17.1,32.6,19.3,71.6,5.6,106.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.8,497.6c-35.5-9.9-65.4-35-81.1-68.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M389.9,106L215,81.8c-8.7-1.2-20.2,3.4-25.5,10.4l-107.5,139c-5.4,6.9-2.6,13.6,6.1,14.8L263,270.2 c8.7,1.2,20.2-3.4,25.6-10.4L396,120.8C401.4,113.8,398.7,107.2,389.9,106L389.9,106z M260,178.9c-7.1,9.2-22.3,15.4-33.9,13.8 c-11.6-1.6-15.2-10.4-8.1-19.6c7.1-9.2,22.3-15.4,33.9-13.8C263.5,160.9,267.1,169.7,260,178.9L260,178.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M416.8,127.1c-3.3-8.1-10.4-9.1-15.8-2.1L292.5,264.4c-5.4,7-7.1,19.2-3.8,27.3l66.7,162.6 c3.3,8.1,10.4,9.1,15.8,2.1l108.4-139.4c5.4-7,7.1-19.2,3.8-27.3L416.8,127.1z M342.2,303.4c-7.2,9.2-16.6,8-21-2.8 c-4.4-10.8-2.2-27,5-36.3c7.2-9.3,16.6-8,21,2.8C351.6,277.9,349.4,294.2,342.2,303.4L342.2,303.4z M394.1,310.3 c-7.2,9.2-16.6,8-21-2.8c-4.4-10.8-2.2-27,5-36.3c7.2-9.3,16.6-8,21,2.8C403.5,284.8,401.3,301.1,394.1,310.3L394.1,310.3z  M446,317.2c-7.2,9.2-16.6,8-21-2.8c-4.4-10.8-2.2-27,5-36.3c7.2-9.2,16.6-8,21,2.8C455.4,291.7,453.2,308,446,317.2L446,317.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.3,276.9l-175-24.2c-8.7-1.2-13.2,4.4-9.9,12.6l65.7,163c3.3,8.1,13,15.7,21.8,17l175,24.2 c8.7,1.2,13.1-4.4,9.9-12.6l-65.7-163C280.7,285.7,271,278.1,262.3,276.9L262.3,276.9z M191.1,425.8c-11.6-1.6-24.5-11.7-28.9-22.5 c-4.4-10.8,1.5-18.3,13.1-16.7c11.6,1.6,24.5,11.7,28.9,22.5C208.5,419.9,202.6,427.4,191.1,425.8L191.1,425.8z M150.1,325.1 c-11.6-1.6-24.5-11.7-28.9-22.5c-4.4-10.8,1.5-18.3,13.1-16.7c11.6,1.6,24.5,11.7,28.9,22.5C167.6,319.3,161.7,326.7,150.1,325.1 L150.1,325.1z M221.5,380.6c-11.6-1.6-24.5-11.7-28.9-22.5c-4.4-10.8,1.5-18.3,13.1-16.7c11.6,1.6,24.5,11.7,28.9,22.5 C239,374.8,233.1,382.2,221.5,380.6L221.5,380.6z M292.9,436.1c-11.6-1.6-24.5-11.7-28.9-22.5c-4.4-10.8,1.5-18.3,13.1-16.6 c11.6,1.6,24.5,11.7,28.9,22.5C310.3,430.2,304.5,437.7,292.9,436.1L292.9,436.1z M251.9,335.5c-11.6-1.6-24.5-11.7-28.9-22.5 c-4.4-10.8,1.5-18.3,13.1-16.7c11.6,1.6,24.6,11.7,28.9,22.5C269.4,329.6,263.5,337.1,251.9,335.5L251.9,335.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_1_",
    points: "790.6,644 790.6,1344 90.6,1344  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098190469522128317390000010673913491860742304_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_00000067916147212730304970000005378102942157273771_",
    points: "924,644 924,1344 224,1344  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000086664886827587323230000016963872487044468879_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067916147212730304970000005378102942157273771_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_00000157269289175113494110000010383304608668804491_",
    points: "973.8,644 973.8,1344 273.8,1344  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145737351231314725860000014418039293122333847_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000157269289175113494110000010383304608668804491_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_00000016076182260949191350000010547266606270538382_",
    points: "993.8,644 993.8,1344 293.8,1344  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036930753285738521290000011123586670353511304_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000016076182260949191350000010547266606270538382_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_00000113334155767533572640000011593496133918405270_",
    points: "1038.6,644 1038.6,1344 338.6,1344  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129928161106416354880000002863298597306685065_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000113334155767533572640000011593496133918405270_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_00000052072716573779848670000017907879864387532693_",
    points: "717.2,672 717.2,1372 17.2,1372  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109746926321786540210000005260583131385630116_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052072716573779848670000017907879864387532693_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_00000110454592331700152080000013319624493579359143_",
    points: "731,672 731,1372 31,1372  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122698723262270854400000003838328964651683997_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000110454592331700152080000013319624493579359143_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_00000076570237421367716520000014955667596492166016_",
    points: "789.2,672 789.2,1372 89.2,1372  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096042648081016179950000007819707467509407929_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000076570237421367716520000014955667596492166016_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_00000047045458888282179590000017272644694457490329_",
    points: "802.5,672 802.5,1372 102.5,1372  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105415522064653976720000014076334536057747868_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047045458888282179590000017272644694457490329_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_00000137113296212668953090000005188592609891749797_",
    points: "822.5,672 822.5,1372 122.5,1372  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000141442420558446510320000013916373725664844455_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137113296212668953090000005188592609891749797_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_00000023970394981219654950000008068387283963165833_",
    points: "874.6,672 874.6,1372 174.6,1372  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127034349099483829160000017494293764331385738_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023970394981219654950000008068387283963165833_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_00000014593840886352955000000005215641052166857918_",
    points: "913.8,672 913.8,1372 213.8,1372  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000024698184636508843360000014269560770732969108_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014593840886352955000000005215641052166857918_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_00000166647845174714154850000017929193066533395135_",
    points: "964,672 964,1372 264,1372  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129928292756523494020000016927770580542166426_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000166647845174714154850000017929193066533395135_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_00000183239953938778554750000000215907834667632057_",
    points: "977.8,672 977.8,1372 277.8,1372  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038408620938045019390000001816986237018678912_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183239953938778554750000000215907834667632057_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_00000072976344266452404940000004436620448264382342_",
    points: "1006.7,672 1006.7,1372 306.7,1372  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000018944929098747714950000012560528201004640414_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072976344266452404940000004436620448264382342_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_00000035522754977774966580000001033232800979897788_",
    points: "1025.6,672 1025.6,1372 325.6,1372  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160872834463099389200000014346323412092584381_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000035522754977774966580000001033232800979897788_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "SVGID_00000153696636173172744620000009911814534414278039_",
    points: "1042.2,672 1042.2,1372 342.2,1372  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054945173663736112720000007357865961732682632_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000153696636173172744620000009911814534414278039_",
    style: {
      overflow: "visible"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDice);
export default __webpack_public_path__ + "static/media/dice.798fb8a587aba3fe137bba017d038943.svg";
export { ForwardRef as ReactComponent };